import { useRef, useMemo, useEffect } from 'react';
import { createPortal } from 'react-dom';
function safeAppendChild(parent, child) {
    if (!parent || !child || parent.contains(child))
        return child;
    return parent.appendChild(child);
}
function safeRemoveChild(parent, child) {
    if (!parent || !child || !parent.contains(child))
        return child;
    return parent.removeChild(child);
}
var usePortal = function (aboveAppPortalId, belowAppPortalId) {
    if (aboveAppPortalId === void 0) { aboveAppPortalId = 'above-app-portal'; }
    if (belowAppPortalId === void 0) { belowAppPortalId = 'below-app-portal'; }
    var aboveAppDiv = document.getElementById(aboveAppPortalId);
    var belowAppDiv = document.getElementById(belowAppPortalId);
    var aboveAppChild = useRef(document.createElement('div'));
    var belowAppChild = useRef(document.createElement('div'));
    return useMemo(function () {
        var handleAppendChildren = function () {
            safeAppendChild(aboveAppDiv, aboveAppChild.current);
            safeAppendChild(belowAppDiv, belowAppChild.current);
        };
        var handleRemoveChildren = function () {
            safeRemoveChild(aboveAppDiv, aboveAppChild.current);
            safeRemoveChild(belowAppDiv, belowAppChild.current);
        };
        var AboveAppPortal = function (_a) {
            var children = _a.children;
            return createPortal(children, aboveAppChild.current);
        };
        var BelowAppPortal = function (_a) {
            var children = _a.children;
            return createPortal(children, belowAppChild.current);
        };
        var useTogglePortalRoot = function () {
            return useEffect(function () {
                handleAppendChildren();
                return handleRemoveChildren;
            }, []);
        };
        return {
            AboveAppPortal: AboveAppPortal,
            BelowAppPortal: BelowAppPortal,
            useTogglePortalRoot: useTogglePortalRoot,
            handleAppendChildren: handleAppendChildren,
            handleRemoveChildren: handleRemoveChildren,
        };
    }, [aboveAppDiv, belowAppDiv]);
};
export default usePortal;
//# sourceMappingURL=index.js.map